import 'focus-visible';
import Drupal from './core/Drupal';
import DDTemplates from './core/DDTemplates';
import CalendarFeed from './core/CalendarFeed';
import TermNavigation from './core/TermNavigation';
import FetchSourceImages from './core/FetchSourceImages';
import AccordionWrap from './core/AccordionWrap';
import AccordionFix from './core/AccordionFix';
import AccordionContainer from './core/AccordionContainer';
import Sticky from './utils/Sticky';
import Visible from './utils/Visible';
// import BackgroundImage from './core/BackgroundImage';
// Header Components
import Navigation from './components/Navigation';
import FixNavigation from './core/FixNavigation';
import MenuPods from './components/MenuPods';
import Headroom from './components/Headroom';
import Toolbar from './header/Toolbar';
// Homepage Components
import Hero from './home/Hero';
import Connect from './home/Connect';
import Pods from './home/Pods';
import Featured from './home/Featured';
import Infographic from './home/Infographic';

// ----------------------------------------------------------------------------
// Homepage Specific Behaviors.
// ----------------------------------------------------------------------------

const homeBehaviors = () => {
  // Homepage Blocks
  document.querySelectorAll('.front .page-main .block, .home-page-two, .home-page-four').forEach((element) => {
    if (!element.Visible) {
      element.Visible = new Visible(element);
    }
  });

  // Hero
  document.querySelectorAll('.home-hero.block').forEach((element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // Home Connect
  document.querySelectorAll('.home-connect.block').forEach((element) => {
    if (!element.Connect) {
      element.Connect = new Connect(element);
    }
  });

  // Home Pods
  document.querySelectorAll('.home-pods.block').forEach((element) => {
    if (!element.Pods) {
      element.Pods = new Pods(element);
    }
  });

  // Home Featured
  document.querySelectorAll('.home-featured.block').forEach((element) => {
    if (!element.Featured) {
      element.Featured = new Featured(element);
    }
  });

  // Home Infographic
  document.querySelectorAll('.node-home-hero.infographic').forEach((element) => {
    if (!element.Infographic) {
      element.Infographic = new Infographic(element);
    }
  });

  // Homepage Block Ready State
  document.querySelectorAll('.front .page-main .block:not(.ready)').forEach((element) => {
    setTimeout(() => {
      element.classList.add('ready');
    }, 200);
  });

  // ----------------------------------------------------------------------------
  // If there is no home-stats block (Meeting Agendas) on homepage,
  // add empty column with a message and button at the bottom.
  // ----------------------------------------------------------------------------

  const homePageTwo = document.querySelector('.home-page-two .layout .inner');
  const homeStats = document.querySelector('.home-page-two .home-stats');
  if (!homeStats) {
    homePageTwo.insertAdjacentHTML('beforeend', '<div id="block-views_blocks-term-block_1-13" class="block block-views_blocks region-odd odd region-count-3 count-9 with-block-editing sort-scope-sitewide home-stats views-block channel context-template ready visible"><div class="block-inner"><p class="block-title h2"><span class="block-title-text">Meeting Agendas</span></p><div class="block-content"><div class="node node-home-stat pt216 dd-hover-help ddHover-processed"><header class="node-header"><p class="subtitle">There are no agendas to display at this time.</p></header></div></div><div class="block-footer"><a class="btn-primary ext" href="https://zone7.docsonthecloud.com/WebLink/Welcome.aspx" target="_blank"> Archived Board Documents</a></div></div></div>');
  }

  function moveFeaturedVideo() {
    const elementToMove = document.getElementById('block-views_blocks-term-block_1-21');
    const parentElement = document.querySelector('.home-page-two .inner');
    parentElement.insertAdjacentElement('afterend', elementToMove);
  }
  moveFeaturedVideo();
};

// ----------------------------------------------------------------------------
// Core Theme Behaviors.
// ----------------------------------------------------------------------------

const coreBehaviors = () => {
  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates();
  }

  // Fix our damn menus from displaying orphaned children
  document.querySelectorAll('.main-navigation, .term-navigation').forEach((element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  document.querySelectorAll('.page-sidebar').forEach((element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  document.querySelectorAll('#nice-menu-3').forEach((element) => {
    if (!element.Navigation) {
      element.Navigation = new Navigation(element);
    }
    // if (!element.MobileMenu) {
    //   element.MobileMenu = new MobileMenu(element);
    // }
    if (!element.MenuPods) {
      element.MenuPods = new MenuPods(element);
    }
  });

  // Controls the states of the menu and search states
  document.querySelectorAll('.toolbar').forEach((element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Fixed Header using Headroom.js
  document.querySelectorAll('.headroom').forEach((element) => {
    if (!element.Headroom) {
      element.Headroom = new Headroom(element);
    }
  });

  // Term Navigation
  document.querySelectorAll('.term-navigation').forEach((element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Calendar of Events View
  document.querySelectorAll('.calendar-feed').forEach((element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element, {
        useFilters: true,
        filterByPostTypes: true,
      });
    }
  });

  // Banner
  document.querySelectorAll('.banner:not(.placeholder-block)').forEach((element) => {
    if (!element.Banner) {
      // element.Banner = new BackgroundImage(element, {
      //   sourceSelector: 'figure img',
      //   destSelector: '.node-banner',
      // });
      document.body.classList.add('has-banner');
    }
  });

  // Wraps each accordion element
  document.querySelectorAll('.accordion-heading').forEach((element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  document.querySelectorAll('.node-content').forEach((element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });
};

// ----------------------------------------------------------------------------
// Load homepage behaviors if we're on the frontpage.
// ----------------------------------------------------------------------------

if (document.body.classList.contains('front')) {
  Drupal.behavior(homeBehaviors);
}

// ----------------------------------------------------------------------------
// Load core behaviors.
// ----------------------------------------------------------------------------

Drupal.behavior(coreBehaviors);

// ----------------------------------------------------------------------------
// If we're in development mode...
// Open up all missing images within a new tab/window.
// ----------------------------------------------------------------------------

if (process.env.NODE_ENV === 'development') {
  document.body.FetchSourceImages = new FetchSourceImages();
}
